import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
/*COMPONENTS */
import SidebarEl from '../../components/SidebarEl'
import styled from 'styled-components'

import MobileMenu from '../../components/MobileMenu'
import Header from '../../components/Header'
import { ToastContainer } from 'react-toastify';
import TableListGoogle from '../../components/TableListGoogle'
import Filter from '../../components/Filter'
import ModalGoogle from '../../components/ModalGoogle'
import { PostsContext } from '../../context/posts'

const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const GoogleMerchantCenter = () => {
    const {getByName} = useContext(PostsContext)

    const [data] = useState([
        {
            name: "Id"
        },
        {
            name:"Post"
        },
        {
            name: "Imagem"
        },
      
    ])
    const [modalShow, setModalShow] = useState(false)


    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <ToastContainer />
            <CardWrapper>

                <div className='colum_primary'>
                    <SidebarEl />
                </div>

                <FixWidthSidebar />

                <div className='colum_secondary'>
                    <Header name={"Google Merchant Center"} />
                    <Filter buttonName={"Adicionar"} onChange={(e) => getByName(e.target.value)} onClick={() => setModalShow(true)} type={1} />
                    <TableListGoogle structure={data} />

                </div>

                <MobileMenu />
                <ModalGoogle
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                />
            </CardWrapper>
        </motion.div>

    )
}

export default GoogleMerchantCenter